// src/utils/bookings.js
import { $toast } from "@/utils/useToast";
import axios from "axios";

// Función para crear reservas
export async function createBooking(data) {
  try {
    const response = await axios.post(`/create/new-booking`, data);
    return response;
  } catch (error) {
    // Manejo de errores específicos del backend
    if (error.response && error.response.data) {
      const backendError = error.response.data;

      // Caso 1: Error con estructura {error: "mensaje", code: "tipo"}
      if (backendError.error) {
        $toast.error(backendError.error); // Muestra el mensaje de error directamente
      }
      // Caso 2: Errores de validación clásicos de Laravel (con array errors)
      else if (backendError.errors) {
        Object.keys(backendError.errors).forEach((key) => {
          backendError.errors[key].forEach((errorMessage) => {
            $toast.error(errorMessage);
          });
        });
      }
      // Caso 3: Mensaje genérico si no hay estructura reconocida
      else {
        $toast.error(
          backendError.message || "Ocurrió un error al crear la reserva"
        );
      }
    } else {
      $toast.error("Error de conexión o servidor no disponible");
    }

    throw error; // Relanza el error para manejo adicional si es necesario
  }
}

// En bookings.js
export async function updateBooking(data) {
  try {
    const response = await axios.put(`/update/booking/${data.id}`, data);
    return response;
  } catch (error) {
    if (error.response && error.response.data) {
      const backendError = error.response.data;

      if (backendError.error) {
        $toast.error(backendError.error);
      } else if (backendError.errors) {
        Object.keys(backendError.errors).forEach((key) => {
          backendError.errors[key].forEach((errorMessage) => {
            $toast.error(errorMessage);
          });
        });
      } else {
        $toast.error(
          backendError.message || "Ocurrió un error al actualizar la reserva"
        );
      }
    } else {
      $toast.error("Error de conexión o servidor no disponible");
    }

    throw error;
  }
}

export async function handleBookingCancellation(reservationData) {
  try {
    const payload = {
      booking_id: reservationData.id,
    };
    const response = await axios.post("/booking/cancelled", payload);
    console.log(response);
    // Si es exitoso, actualizar el estado
    reservationData.status = "cancelled";
  } catch (error) {
    $toast.error("Error al procesar la solicitud");
  }
}
